export default "__VITE_ASSET__be533ca4__"